import { API } from '../constants/constants';
import { normalizeAnalyticsChartQuery } from '../utils/analyticsChartQueryNormalization';

const buildAnalyticsQuery = (query, extraParams) => {
  const normalizedQuery = normalizeAnalyticsChartQuery(query);
  if (!extraParams) return normalizedQuery;
  const extraQuery = new URLSearchParams(extraParams).toString();
  if (!normalizedQuery) return extraQuery;
  if (!extraQuery) return normalizedQuery;
  return `${normalizedQuery}&${extraQuery}`;
};

const withAnalyticsQuery = (path, query, extraParams) => {
  const queryString = buildAnalyticsQuery(query, extraParams);
  return queryString ? `${path}?${queryString}` : path;
};

export const getInteractionsTable = async (query) => {
  try {
    const response = await API.get(`/issues/media/filter?${query}`);
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getServicesTable = async (query) => {
  try {
    const response = await API.get(`/services/filter?${query}`);
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMediaInteractionsChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getIssueFilteredMIChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/issues/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getIssueResponseMIChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/responses/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getProactiveServicesChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/services/proactive/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getProactiveMRChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/services/tactic/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getReactiveServicesChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/services/reactive/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTeamDrivenMIChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/team/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInstitutionalStoryMIChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/institutional/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getProactiveMIChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/proactive/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getCampaignsMIChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/campaigns/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getCampaignsServiceChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/services/campaigns/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getIssueComplexityChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/services/complexity/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInteractionsByMember = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/interactions/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getServicesByMember = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/services/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInProgressInteraction = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/interactions/progress/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data.issues;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getApplesData = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/apples/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getPvrData = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/pvr/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getComplexityChartData = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/complexity/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getCampaignsChartData = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/campaigns/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopMediaHits = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('custom/media/topMediaHits/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopServiceHits = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('custom/media/topServiceHits/filter', query));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopMediaTopics = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('custom/media/topMediaTopics/filter', query, { limit: 5, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopInteractionTopicsOverall = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topInteractionTopics/filter', query, { limit: 5, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMoreInteractionTopicsOverall = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topInteractionTopics/filter', query, { limit: 20, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const get50InteractionTopicsOverall = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topInteractionTopics/filter', query, { limit: 50, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopProactiveTopics = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topProactiveTopics/filter', query, { limit: 5, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMoreMediaTopics = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topMediaTopics/filter', query, { limit: 20, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};
export const get50MediaTopics = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topMediaTopics/filter', query, { limit: 30, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};
export const getMoreProactiveTopics = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topProactiveTopics/filter', query, { limit: 20, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const get50ProactiveTopics = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/topProactiveTopics/filter', query, { limit: 50, normalizeTopic: true })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getExperts = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/topExperts/filter', query, { limit: 150 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInteractionsByType = async (query) => {
  try {
    const res = await API.get(
      withAnalyticsQuery('/custom/media/mediaInteractionsByType/filter', query, { limit: 150 })
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopComplexServices = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/topComplexServices/filter', query, { limit: 5 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMoreComplexServices = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/topComplexServices/filter', query, { limit: 20 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getServicesByType = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/servicesByType/filter', query, { limit: 150 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getOutletsChartData = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/outlets/filter', query, { limit: 20 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getServicesByUnit = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/servicesByUnit/filter', query, { limit: 150 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInteractionsByUnit = async (query) => {
  try {
    const res = await API.get(withAnalyticsQuery('/custom/media/interactionsByUnit/filter', query, { limit: 150 }));
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getEngagementsChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/engagements', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTotalCommunityMembersChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/engagements/community-members', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getToneOfInteractionsChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/interactions/tone', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getCampaignsEngagementChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/media/engagements/campaigns/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInteractionsByStatusChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/custom/media/interactionsByStatus/filter/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getServicesByStatusChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/custom/media/servicesByStatus/filter/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getInteractionsByToneChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/custom/media/interactionsByTone/filter/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getOrganizationsEngagedChart = async (query) => {
  try {
    const response = await API.get(
      withAnalyticsQuery('/custom/media/organizationEngaged/filter/', query, { limit: 5 })
    );
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMoreOrganizationsEngagedChart = async (query) => {
  try {
    const response = await API.get(
      withAnalyticsQuery('/custom/media/organizationEngaged/filter/', query, { limit: 20 })
    );
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getEngagementsByTypeChart = async (query) => {
  try {
    const response = await API.get(withAnalyticsQuery('/custom/media/engagementsByType/filter/', query));
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopEngagementTopicsChart = async (query) => {
  try {
    const response = await API.get(
      withAnalyticsQuery('/custom/media/topEngagementTopics/filter/', query, { limit: 150 })
    );
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getTopEngagementTopicsOverall = async (query) => {
  try {
    const response = await API.get(
      withAnalyticsQuery('/custom/media/topEngagementTopics/filter/', query, { limit: 5, normalizeTopic: true })
    );
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMoreEngagementTopicsOverall = async (query) => {
  try {
    const response = await API.get(
      withAnalyticsQuery('/custom/media/topEngagementTopics/filter/', query, { limit: 20, normalizeTopic: true })
    );
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};
